import Vue from 'vue'
import App from './App.vue'
import vant from 'vant'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import axios from '../src/api/axios'
import vueEsign from 'vue-esign'
require('element-ui/lib/theme-chalk/index.css');
import validator from './utils/validator'
import server from './config/server'
import moment from 'moment'
import JsonExcel from 'vue-json-excel'
import utilsUA from '@/utils/utilsUA.js'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import _ from 'lodash'
Vue.use(ElementUI);
Vue.use(vueEsign)
Vue.component('downloadExcel', JsonExcel)
// import Vconsole from 'vconsole'
// const vconsole = new Vconsole()
// Vue.use(vconsole)

Vue.config.devtools = true;

Vue.prototype.$eventBus = new Vue()
Vue.prototype.$validator = validator;
Vue.prototype.$server = server;
    // 引入全局样式
    // import './styles/index.less'
import 'vant/lib/index.css'
import 'amfe-flexible'
// import './utils/dayjs'
Vue.use(vant)
Vue.use(Viewer)
Vue.prototype.$_ = _
Vue.prototype.$http = axios
Vue.prototype.$moment = moment;
Vue.prototype.$utilsUA = utilsUA
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')